// extracted by mini-css-extract-plugin
export default {"avatar__wrapper":"_5DB72kQo","avatar":"_5D3F_KQ7","initial__wrapper":"_5D3FrJRy","initial":"_5D2nfbik"};